import NumberFormat from "react-number-format";

export function BoxSupplier(props) {
  const { suppliers, separacion_miles, separacion_decimales, simbolo } = props;

  return (
    <div className="overflow-hidden rounded-xl border border-border bg-white">
      <div className="flex items-center justify-between border-b border-border px-5 py-4">
        <div>
          <h2 className="text-sm font-semibold text-black/70">Proveedores</h2>
          <p className="text-xs text-gray-500">
            Gastado, pagado y deuda pendiente
          </p>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[640px] text-sm">
          <thead>
            <tr className="border-b border-border bg-[#f8f9fa] text-[11px] uppercase tracking-wide text-gray-500">
              <th className="px-5 py-2.5 text-left font-medium">Proveedor</th>
              <th className="px-3 py-2.5 text-center font-medium">
                Comprobantes
              </th>
              <th className="px-3 py-2.5 text-right font-medium">Gastado</th>
              <th className="px-3 py-2.5 text-right font-medium">Pagado</th>
              <th className="px-3 py-2.5 text-right font-medium">
                Saldo por pagar
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {suppliers.map((p) => {
              return (
                <tr
                  key={p.ruc}
                  className="transition-colors hover:bg-gray-200/40 text-sm"
                >
                  <td className="px-5 py-3">
                    <p className="font-medium uppercase">{p.proveedor}</p>
                  </td>
                  <td className="num whitespace-nowrap px-3 py-3 text-center text-muted-foreground">
                    {p.cantidad}
                  </td>
                  <td className="px-3 py-3 text-right">
                    <NumberFormat
                      value={parseFloat(p.total_facturado || 0)}
                      displayType={"text"}
                      thousandSeparator={separacion_miles}
                      decimalSeparator={separacion_decimales}
                      prefix={`${simbolo} `}
                      decimalScale={2}
                      fixedDecimalScale={2}
                    />
                  </td>
                  <td className="px-3 py-3 text-right text-green-600">
                    <NumberFormat
                      value={parseFloat(p.total_pagado || 0)}
                      displayType={"text"}
                      thousandSeparator={separacion_miles}
                      decimalSeparator={separacion_decimales}
                      prefix={`${simbolo} `}
                      decimalScale={2}
                      fixedDecimalScale={2}
                    />
                  </td>
                  <td className="text-right pe-3 text-red-600">
                    <NumberFormat
                      value={parseFloat(p.total_por_pagar || 0)}
                      displayType={"text"}
                      thousandSeparator={separacion_miles}
                      decimalSeparator={separacion_decimales}
                      prefix={`${simbolo} `}
                      decimalScale={2}
                      fixedDecimalScale={2}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
